import React, { useState } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { ExportNoticesButton } from "components/notices/ExportNoticesButton";
import { NewNoticeTable } from "components/notices/NewNoticeTable";
import { DEFAULT_PAGINATION } from "components/notices/NoticeTable";
import {
  convertNoticeFiltersToSearchRequest,
  NoticeColumns,
  NoticeFilters,
} from "components/notices/utils";
import Modal from "components/ui/modal/Modal";
import SkeletonText from "components/ui/skeleton/SkeletonText";
import { useNotices } from "lib/hooks/api/notices/useNotices";
import { SortState } from "lib/search/types";

type NoticeModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  filters: NoticeFilters;
  defaultColumnSettings: NoticeColumns[];
  showing: string;
};

const NoticeModal = ({
  open,
  onOpenChange,
  filters,
  defaultColumnSettings,
  showing,
}: NoticeModalProps) => {
  const [selectedNotices, setSelectedNotices] = useState<string[]>();
  const [sortOrder, setSortOrder] = useState<SortState | undefined>(undefined);

  const { data: noticeSearch, isLoading } = useNotices(
    convertNoticeFiltersToSearchRequest(filters, DEFAULT_PAGINATION),
    false,
    {
      enabled: open,
    },
  );

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContainer column gap="24px">
        <Text h1>Analyse results</Text>
        <Flex justifyContent="space-between" alignItems="center">
          <TextAligned>
            Showing
            {isLoading ? (
              <SkeletonText as="span" width="40px" />
            ) : (
              ` ${noticeSearch.pagingInfo.totalResults} `
            )}
            notices for {showing}
          </TextAligned>
          <ExportNoticesButton filters={filters} selectedNotices={selectedNotices} />
        </Flex>
        <NewNoticeTable
          filters={{
            ...filters,
            sort: sortOrder ?? filters.sort,
          }}
          columnSettings={defaultColumnSettings}
          onSortChange={(sortOrder: SortState) => setSortOrder(sortOrder)}
          selectedRows={selectedNotices}
          onSelectedRowsChange={(rows) => setSelectedNotices(rows)}
        />
      </ModalContainer>
    </Modal>
  );
};

const ModalContainer = styled(Flex)({
  minHeight: "1000px",
  padding: "18px",
});

const TextAligned = styled(Text)({
  display: "inline-flex",
  gap: "4px",
});

export default NoticeModal;
